module.exports = __webpack_public_path__ + "static/media/infoscore_icon.7def937c.svg";